import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {
  FRONTEND_REGISTER_URL,
  FRONTEND_SINGLE_TENANCY_REGISTER_URL,
  FRONTEND_REGISTER_USER_URL,
  FRONTEND_REGISTER_USER_WITH_MAGIC_CODE_URL,
  FRONTEND_REGISTER_USER_WITH_ACCESS_CODE_URL,
  FRONTEND_LOGIN_URL,
  FRONTEND_FORGOTPASS_URL,
  FRONTEND_RESENDACTIVATION_URL,
  FRONTEND_PASSWORDRESET_URL,
  FRONTEND_VERIFYACCOUNT_URL,
  FRONTEND_UNSUBSCRIBE_URL,
  API_URL,
  HOME_URL,
  WELCOME_URL,
  STORIES_URL,
  STORIES_FOLLOWING_URL,
  CONTENT_MANAGEMENT_URL,
  LATEST_ACCESS,
  CONTENT_MANAGEMENT_CREATE_URL,
  CONTENT_MANAGEMENT_ADDS3_URL,
  UPLOAD_ZIPPED_UNIT_URL,
  CONTENT_MANAGEMENT_MODERATE_URL,
  CONTENT_MANAGEMENT_CATEGORIES_URL,
  USER_MANAGEMENT_URL,
  USER_MANAGEMENT_ADD_USER_URL,
  USER_MANAGEMENT_ADD_GROUP_URL,
  CREATE_URL,
  GUIDES_URL,
  IDEOLOGY_URL,
  SETTINGS_URL,
  SEARCH_URL,
  REPORTS_URL,
  PROFILE_URL,
  NOTIFICATIONS_URL,
  MESSAGES_URL,
  LIBRARY_URL,
  LEADERBOARDS_URL,
  UNITOVERVIEW_URL,
  INITIAL_SETUP_URL,
  CUSTOMIZE_LYKIO_URL,
  RESET_LEADERBOARDS_URL,
  UNITIFRAME_URL,
  GAMEIFRAME_URL,
  INTERVIEWIFRAME_URL,
  PLANS_URL,
  STRIPE_PAYMENT_URL,
  PLAYLISTS_URL,
  UBER_ADMIN_SETTINGS_URL,
  DEPARTMENTS_URL,
  CREATE_ACCESS_CODE_URL,
  PROGRESS_URL,
  GROUP_USERS_PARAM_URL,
  AWARD_URL,
  PLAYLIST_URL,
  USER_EDIT_URL,
  UNIT_EDIT_URL,
  FRONTEND_DOWNLOAD_GAME_URL,
  CONTENT_CREATION,
  CONTENT_CREATION_GUIDE,
  CHAT_URL,
  CONNECTIONS_URL,
  EDUCATIONAL_USER_MANAGEMENT_WITHOUTPARAM_URL,
  EDUCATIONAL_USER_EDIT_WITHOUTPARAM_URL,
  EDUCATIONAL_USER_EDIT_URL, TT_REPORTING, GAMEIFRAME_INTRO_URL, INTERVIEWIFRAME_INTRO_URL, REDIRECT_URL,
  ASSESSMENTIFRAME_INTRO_URL, ASSESSMENTIFRAME_URL,
  ADD_EDITION_CODE_URL,
  UPDATE_EDITION_CODE_STATUS
} from './Utils/Constants';

import RegisterScreen from './components/auth/RegisterScreen';
import SingleTenancyRegisterScreen from './components/auth/SingleTenancyRegisterScreen';
import RegisterSimpleUserScreen from './components/auth/RegisterSimpleUserScreen';
import RegisterWithMagicCode from './components/auth/RegisterWithMagicCode';
import RegisterWithAccessCode from './components/auth/RegisterWithAccessCode'; 
import LoginScreen from './components/auth/LoginScreen';
import UberLoginScreen from './components/auth/UberLoginScreen';
import ForgotPaswordScreen from './components/auth/ForgotPaswordScreen';
import ResetPaswordScreen from './components/auth/ResetPaswordScreen';
import VerifyAccountScreen  from './components/auth/VerifyAccountScreen';
import UnsubscribeScreen from './components/auth/UnsubscribeScreen';
import ResendActivationScreen from './components/auth/ResendActivationScreen';
import API from './components/auth/API';
import CustomizeLykio from './components/admin/CustomizeLykio';
import LykioAuthorizedRoute from './components/routing/LykioAuthorizedRoute';
import LykioOpenRoute from './components/routing/LykioOpenRoute';
import Home from './components/home/Home';
import Stories from './components/stories/Stories';
import StoriesFollowing from './components/stories/StoriesFollowing';
import ContentManagement from './components/contentmanagement/ContentManagement';
import GrapesContentCreation from './components/contentmanagement/GrapesContentCreation';
import ContentModeration from './components/contentmanagement/ContentModeration';
import CategoriesManagement from './components/contentmanagement/CategoriesManagement';
import ContentS3Upload from './components/contentmanagement/ContentS3Upload';
import UserManagement from './components/usermanagement/UserManagement';
import AddUser from './components/usermanagement/AddUser';
import AddGroup from './components/usermanagement/AddGroup';
import Create from './components/stories/Create';
import Guides from './components/guides/Guides';
import Ideology from './components/ideology/Ideology';
import Settings from './components/settings/Settings';
import Search from './components/search/Search';
import Reports from './components/reports/Reports';
import Profile from './components/profile/Profile';
import Notifications from './components/notifications/Notifications';
import Messages from './components/messages/Messages';
import Library from './components/library/Library';
import Leaderboards from './components/leaderboards/Leaderboards';
import UnitOverview from './components/library/UnitOverview';
import UnitIFrame from './components/library/UnitIFrame';
import FirstAdminScreen from './components/admin/FirstAdminScreen';
import Plans from './components/billing/Plans';
import StripeContainer from './components/billing/StripeContainer';
import Playlists from './components/favourites/Playlists';
import UberScreen from './components/admin/UberScreen';
import AddDepartment from './components/usermanagement/AddDepartment';
import AddAccessCode from './components/admin/AddAccessCode';
import Progress from './components/profile/Progress';
import ZipContentUpload from './components/contentmanagement/ZipContentUpload';
import Group from './components/usermanagement/Group';
import AddAward from './components/admin/AddAward';
import AddPlaylist from './components/playlists/AddPlaylist';
import Welcome from './components/home/Welcome';
import EditUser from './components/usermanagement/EditUser';
import EditUnit from './components/contentmanagement/EditUnit';
import ResetLeaderboards from './components/admin/ResetLeaderboards';
import Chat from './components/chat/Chat';
import DownloadPage from './components/auth/DownloadPage';
import ContentCreationDashboard from './components/contentmanagement/ContentCreationDashboard';
import ContentCreationGuide from './components/guides/ContentCreationGuide';
import Connections from "./components/connections/Connections";
import EducationalUserManagement from './components/educational/UserManagement'
import EducationalUserEdit from './components/educational/EditUser';
import TTReporting  from './components/educational/TTReporting';
import Test from './components/eni/Test';
import TestEN from './components/eni/TestEN';
import Test2 from './components/eni/Test2';
import TestEN2 from './components/eni/TestEN2';
import Test3 from './components/eni/Test3';
import TestEN3 from './components/eni/TestEN3';
import Assessment from './components/eni/Assessment/Assessment';
import Interview from './components/eni/Interview';
import Insights from './components/eni/Insights';
import Tests from './components/eni/Tests';
import Assessments from './components/eni/Assessments';
import Interviews from './components/eni/Interviews';
import Quizzes from './components/eni/Quizzes';
import QuizIframe from './components/eni/QuizIframe';
import InterviewIframe from './components/eni/InterviewIframe';
import {PublicClientApplication} from "@azure/msal-browser";
import {MsalProvider} from "@azure/msal-react";
import IframeIntro from "./components/eni/IframeIntro";
import AssementIframe from "./components/eni/AssessmentIframe";
import Loading from "./components/common/Loading";
import LatestAccess from './components/usermanagement/LatestAccess';


const App = () => {
  const config = {
    auth: {
      clientId: "a1f09ad1-60c0-4779-8b87-64950b4a3511",
      authority: "https://login.microsoftonline.com/c16e514b-893e-4a01-9a30-b8fef514a650", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
      redirectUri: "https://logosnet-eni.lyk.io/login",
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    }
  };

  const msalInstance = new PublicClientApplication(config);
  return (
      <MsalProvider instance={msalInstance}>
        <Router>
          <div className="app">
            <Routes>
              <Route path={API_URL} element={<LykioOpenRoute><API /></LykioOpenRoute>} />
              <Route path={FRONTEND_REGISTER_URL} element={<LykioOpenRoute><RegisterScreen /></LykioOpenRoute>} />
              <Route path={FRONTEND_SINGLE_TENANCY_REGISTER_URL} element={<LykioOpenRoute><SingleTenancyRegisterScreen /></LykioOpenRoute>} />
              <Route path={FRONTEND_REGISTER_USER_URL} element={<LykioOpenRoute><RegisterSimpleUserScreen /></LykioOpenRoute>} />
              <Route path={FRONTEND_REGISTER_USER_WITH_MAGIC_CODE_URL} element={<LykioOpenRoute><RegisterWithMagicCode /></LykioOpenRoute>} />
              <Route path={FRONTEND_REGISTER_USER_WITH_ACCESS_CODE_URL} element={<LykioOpenRoute><RegisterWithAccessCode /></LykioOpenRoute>} />
              <Route path={FRONTEND_LOGIN_URL} element={<LykioOpenRoute><LoginScreen /></LykioOpenRoute>} />
              <Route path={'guestlogin'} element={<LykioOpenRoute><UberLoginScreen /></LykioOpenRoute>} />
              <Route path={FRONTEND_FORGOTPASS_URL} element={<LykioOpenRoute><ForgotPaswordScreen /></LykioOpenRoute>} />
              <Route path={FRONTEND_RESENDACTIVATION_URL} element={<LykioOpenRoute><ResendActivationScreen /></LykioOpenRoute>} />
              <Route path={FRONTEND_PASSWORDRESET_URL} element={<LykioOpenRoute><ResetPaswordScreen /></LykioOpenRoute>} />
              <Route path={FRONTEND_VERIFYACCOUNT_URL} element={<LykioOpenRoute><VerifyAccountScreen /></LykioOpenRoute>} />
              <Route path={FRONTEND_UNSUBSCRIBE_URL} element={<LykioOpenRoute><UnsubscribeScreen /></LykioOpenRoute>} />
              <Route path={FRONTEND_DOWNLOAD_GAME_URL} element={<LykioOpenRoute><DownloadPage /></LykioOpenRoute>} />
              <Route path={HOME_URL} element={<LykioAuthorizedRoute><Home /></LykioAuthorizedRoute>} />
              <Route path={WELCOME_URL} element={<LykioAuthorizedRoute><Welcome /></LykioAuthorizedRoute>} />
              <Route path={STORIES_URL} element={<LykioAuthorizedRoute><Stories /></LykioAuthorizedRoute>} />
              <Route path={STORIES_FOLLOWING_URL} element={<LykioAuthorizedRoute><StoriesFollowing /></LykioAuthorizedRoute>} />
              <Route path={CONTENT_MANAGEMENT_URL} element={<LykioAuthorizedRoute><ContentManagement /></LykioAuthorizedRoute>} />
              <Route path={LATEST_ACCESS} element={<LykioAuthorizedRoute><LatestAccess /></LykioAuthorizedRoute>} />
              <Route path={CONTENT_CREATION} element={<LykioAuthorizedRoute><ContentCreationDashboard /></LykioAuthorizedRoute>} />
              <Route path={CONTENT_CREATION_GUIDE} element={<LykioAuthorizedRoute><ContentCreationGuide /></LykioAuthorizedRoute>} />
              <Route path={CONTENT_MANAGEMENT_CREATE_URL} element={<LykioAuthorizedRoute><GrapesContentCreation /></LykioAuthorizedRoute>} />
              <Route path={CONTENT_MANAGEMENT_ADDS3_URL} element={<LykioAuthorizedRoute><ContentS3Upload /></LykioAuthorizedRoute>} />
              <Route path={UPLOAD_ZIPPED_UNIT_URL} element={<LykioAuthorizedRoute><ZipContentUpload /></LykioAuthorizedRoute>} />
              <Route path={CONTENT_MANAGEMENT_MODERATE_URL} element={<LykioAuthorizedRoute><ContentModeration /></LykioAuthorizedRoute>} />
              <Route path={CONTENT_MANAGEMENT_CATEGORIES_URL} element={<LykioAuthorizedRoute><CategoriesManagement /></LykioAuthorizedRoute>} />
              <Route path={UNIT_EDIT_URL} element={<LykioAuthorizedRoute><EditUnit /></LykioAuthorizedRoute>}/>
              <Route path={USER_MANAGEMENT_URL} element={<LykioAuthorizedRoute><UserManagement /></LykioAuthorizedRoute>}/>
              <Route path={USER_MANAGEMENT_ADD_USER_URL} element={<LykioAuthorizedRoute><AddUser /></LykioAuthorizedRoute>}/>
              <Route path={USER_EDIT_URL} element={<LykioAuthorizedRoute><EditUser /></LykioAuthorizedRoute>}/>
              <Route path={USER_MANAGEMENT_ADD_GROUP_URL} element={<LykioAuthorizedRoute><AddGroup /></LykioAuthorizedRoute>}/>
              <Route path={CREATE_URL} element={<LykioAuthorizedRoute><Create /></LykioAuthorizedRoute>} />
              <Route path={GUIDES_URL} element={<LykioAuthorizedRoute><Guides /></LykioAuthorizedRoute>} />
              <Route path={IDEOLOGY_URL} element={<LykioAuthorizedRoute><Ideology /></LykioAuthorizedRoute>} />
              <Route path={SETTINGS_URL} element={<LykioAuthorizedRoute><Settings /></LykioAuthorizedRoute>} />
              <Route path={SEARCH_URL} element={<LykioAuthorizedRoute><Search /></LykioAuthorizedRoute>} />
              <Route path={REPORTS_URL} element={<LykioAuthorizedRoute><Reports /></LykioAuthorizedRoute>} />
              <Route path={PROFILE_URL} element={<LykioAuthorizedRoute><Profile /></LykioAuthorizedRoute>} />
              <Route path={PROGRESS_URL} element={<LykioAuthorizedRoute><Progress /></LykioAuthorizedRoute>} />
              <Route path={NOTIFICATIONS_URL} element={<LykioAuthorizedRoute><Notifications /></LykioAuthorizedRoute>} />
              <Route path={MESSAGES_URL} element={<LykioAuthorizedRoute><Messages /></LykioAuthorizedRoute>} />
              <Route path={LIBRARY_URL} element={<LykioAuthorizedRoute><Library /></LykioAuthorizedRoute>} />
              <Route path={LEADERBOARDS_URL} element={<LykioAuthorizedRoute><Leaderboards /></LykioAuthorizedRoute>} />
              <Route path={UNITOVERVIEW_URL} element={<LykioAuthorizedRoute><UnitOverview /></LykioAuthorizedRoute>} />
              <Route path={UNITOVERVIEW_URL} element={<LykioAuthorizedRoute><UnitOverview /></LykioAuthorizedRoute>} />
              <Route path={UNITIFRAME_URL} element={<LykioAuthorizedRoute><UnitIFrame /></LykioAuthorizedRoute>} />
              <Route path={INITIAL_SETUP_URL} element={<LykioAuthorizedRoute><FirstAdminScreen /></LykioAuthorizedRoute>} />
              <Route path={CUSTOMIZE_LYKIO_URL} element={<LykioAuthorizedRoute><CustomizeLykio /></LykioAuthorizedRoute>} />
              <Route path={RESET_LEADERBOARDS_URL} element={<LykioAuthorizedRoute><ResetLeaderboards /></LykioAuthorizedRoute>} />
              <Route path={PLANS_URL} element={<LykioAuthorizedRoute><Plans /></LykioAuthorizedRoute>} />
              <Route path={STRIPE_PAYMENT_URL} element={<LykioAuthorizedRoute><StripeContainer /></LykioAuthorizedRoute>} />
              <Route path={PLAYLISTS_URL} element={<LykioAuthorizedRoute><Playlists /></LykioAuthorizedRoute>} />
              <Route path={UBER_ADMIN_SETTINGS_URL} element={<LykioAuthorizedRoute><UberScreen /></LykioAuthorizedRoute>} />
              <Route path={DEPARTMENTS_URL} element={<LykioAuthorizedRoute><AddDepartment /></LykioAuthorizedRoute>} />
              <Route path={CREATE_ACCESS_CODE_URL} element={<LykioAuthorizedRoute><AddAccessCode /></LykioAuthorizedRoute>} />
              <Route path={GROUP_USERS_PARAM_URL} element={<LykioAuthorizedRoute><Group /></LykioAuthorizedRoute>} />
              <Route path={AWARD_URL} element={<LykioAuthorizedRoute><AddAward /></LykioAuthorizedRoute>} />
              <Route path={PLAYLIST_URL} element={<LykioAuthorizedRoute><AddPlaylist /></LykioAuthorizedRoute>} />
              <Route path={CHAT_URL} element={<LykioAuthorizedRoute><Chat/></LykioAuthorizedRoute>}/>
              <Route path={CONNECTIONS_URL} element={<LykioAuthorizedRoute><Connections/></LykioAuthorizedRoute>}/>
              <Route path={EDUCATIONAL_USER_MANAGEMENT_WITHOUTPARAM_URL} element={<LykioAuthorizedRoute><EducationalUserManagement/></LykioAuthorizedRoute>}/>
              <Route path={EDUCATIONAL_USER_EDIT_URL} element={<LykioAuthorizedRoute><EducationalUserEdit/></LykioAuthorizedRoute>}/>
              <Route path={TT_REPORTING} element={<LykioAuthorizedRoute><TTReporting/></LykioAuthorizedRoute>}/>

              <Route path={'/test'} element={<LykioAuthorizedRoute><Tests /></LykioAuthorizedRoute>} />
              <Route path={'/test1'} element={<LykioAuthorizedRoute><Test /></LykioAuthorizedRoute>} />
              <Route path={'/testEN1'} element={<LykioAuthorizedRoute><TestEN /></LykioAuthorizedRoute>} />
              <Route path={'/test2'} element={<LykioAuthorizedRoute><Test2 /></LykioAuthorizedRoute>} />
              <Route path={'/testEN2'} element={<LykioAuthorizedRoute><TestEN2 /></LykioAuthorizedRoute>} />
              <Route path={'/test3'} element={<LykioAuthorizedRoute><Test3 /></LykioAuthorizedRoute>} />
              <Route path={'/testEN3'} element={<LykioAuthorizedRoute><TestEN3 /></LykioAuthorizedRoute>} />

              <Route path={'/interview'} element={<LykioAuthorizedRoute><Interview /></LykioAuthorizedRoute>} />
              <Route path={'/interviews'} element={<LykioAuthorizedRoute><Interviews /></LykioAuthorizedRoute>} />


              <Route path={'/assessment'} element={<LykioAuthorizedRoute><Assessment /></LykioAuthorizedRoute>} />
              <Route path={'/assessments'} element={<LykioAuthorizedRoute><Assessments /></LykioAuthorizedRoute>} />


              <Route path={'/activities'} element={<LykioAuthorizedRoute><Quizzes /></LykioAuthorizedRoute>} />

              <Route path={INTERVIEWIFRAME_INTRO_URL} element={<LykioAuthorizedRoute><IframeIntro /></LykioAuthorizedRoute>} />
              <Route path={GAMEIFRAME_INTRO_URL} element={<LykioAuthorizedRoute><IframeIntro /></LykioAuthorizedRoute>} />
              <Route path={ASSESSMENTIFRAME_INTRO_URL} element={<LykioAuthorizedRoute><IframeIntro /></LykioAuthorizedRoute>} />


              <Route path={GAMEIFRAME_URL} element={<LykioAuthorizedRoute><QuizIframe /></LykioAuthorizedRoute>} />
              <Route path={INTERVIEWIFRAME_URL} element={<LykioAuthorizedRoute><InterviewIframe /></LykioAuthorizedRoute>} />
              <Route path={ASSESSMENTIFRAME_URL} element={<LykioAuthorizedRoute><AssementIframe /></LykioAuthorizedRoute>} />

              <Route path={REDIRECT_URL} element={<LykioAuthorizedRoute><Loading/></LykioAuthorizedRoute>}/>

              <Route path={'/insights'} element={<LykioAuthorizedRoute><Insights /></LykioAuthorizedRoute>} />


            </Routes>
          </div>
        </Router>
      </MsalProvider>

    
  );
}

export default App;